module.exports = __webpack_public_path__ + "static/media/Water.9d6633e6.png";